
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlM as ObiOwnShipControlMElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-m.js';
 
 
 

 
 export const ObiOwnShipControlM = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-m',
   elementClass: ObiOwnShipControlMElement,
   events: {
     
   }
  });
 
 